var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "theicons.co/svg/mail-12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "The-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,41.7118768 C44,43.9261601 42.5591022,44.6437111 40.8031923,43.3306699 L31,36 L8.00002553,36 C5.79087243,36 4,34.2109725 4,31.9957423 L4,8.0042577 C4,5.79276724 5.79642476,4 8.00002553,4 L39.9999745,4 C42.2091276,4 44,5.78902751 44,8.0042577 L44,41.7118768 Z M40,8.0042577 L8.00002553,8 L8,31.9957423 L32.330179,32 L40.0379583,37.7637537 L40,8.0042577 Z M24,23 C22.3431458,23 21,21.6568542 21,20 C21,18.3431458 22.3431458,17 24,17 C25.6568542,17 27,18.3431458 27,20 C27,21.6568542 25.6568542,23 24,23 Z M16,23 C14.3431458,23 13,21.6568542 13,20 C13,18.3431458 14.3431458,17 16,17 C17.6568542,17 19,18.3431458 19,20 C19,21.6568542 17.6568542,23 16,23 Z M32,23 C30.3431458,23 29,21.6568542 29,20 C29,18.3431458 30.3431458,17 32,17 C33.6568542,17 35,18.3431458 35,20 C35,21.6568542 33.6568542,23 32,23 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.dc1092c8dfb3eac97d74f47ee557bce7.svg";
export { ForwardRef as ReactComponent };